export const detailUrl = ({ id }) => `/brf-premises/detail/${id}/invoicing`;

export const invoicingToContractDetailUrl = ({ id }) =>
  `/error-redirect/invoicingbrf/${id}`;
